interface JobSiteMapProps {
  address: string;
}

// Uses the free Google Maps embed (no API key needed for basic place embeds).
export const JobSiteMap = ({ address }: JobSiteMapProps) => {
  if (!address?.trim()) return null;

  const src = `https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed&t=m`;

  return (
    <div className="mt-3 overflow-hidden rounded-lg border border-gray-200">
      <iframe
        title="Job site map"
        src={src}
        width="100%"
        height="200"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
};
